export const toCurrency = (value) => {
  value = parseFloat(value)
  if (isNaN(value)) {
    value = 0
  }
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
}
